module.exports = __webpack_public_path__ + "static/desktop/img/statements-lg.3e9dbcdd.jpg";